import React from "react";

const labels = {
  "rangeTypes" : [
    {
      "label": "Worldwide",
      "value": 0
    },
    {
      "label": "Europe",
      "value": 1
    },
  ],

  "freightTypes" : [
    {
      "label": "Land",
      "value": 0
    },
    {
      "label": "Sea",
      "value": 1
    },
    {
      "label": "Air",
      "value": 2
    },
  ],

  "rateRequestModes": [
    // Land
    [
      {
        "label": "DTD (door to door) [Land]",
        "labelLong": "Door to door",
        "labelShort": "DTD",
        "value": 0,
        "info": (<>
          <p>We expect the following services to be included, please also see notes for further info:</p>
          <ul>
            <li>Full packing of small and fragile items into cartons</li>
            <li>Normal disassembly of used furniture</li>
            <li>Full itemized English packing inventory</li>
            <li>Traditional blanket wrap loading or full export wrap, pending on option selected under packing type</li>
            <li>Loading from residence of normal access, max ground and/or 1st and/or 2nd floor</li>
            <li>Road transport to new residence</li>
            <li>Unloading into residence of normal access, max ground and/or 1st and/or 2nd floor</li>
            <li>Normal assembly of disassembled used furniture</li>
            <li>Removal of blankets or full unwrapping pending on option selected under packing type</li>
            <li>Unpacking of cartons onto nearest flat surface</li>
            <li>Removal of packing debris at time of delivery</li>
            <li>Export or import clearance if needed to be quoted separately via notes</li>
          </ul>
        </>),
      },
      {
        "label": "WTD (warehouse to door)",
        "labelLong": "Warehouse to door",
        "labelShort": "WTD",
        "value": 1,
        "info": (<>
          <p>We expect the following services to be included, please also see notes for further info:</p>
          <ul>
            <li>Pending on origin mentioned in this request include transport from our warehouse or;</li>
            <li>FOT receipt of shipment at your warehouse and warehouse handling</li>
            <li>Max 2 weeks free storage at your warehouse</li>
            <li>Road transport to new residence</li>
            <li>Unloading into residence of normal access, max ground and/or 1st and/or 2nd floor</li>
            <li>Normal assembly of disassembled used furniture</li>
            <li>Removal of blankets or full unwrapping pending on option selected under packing type</li>
            <li>Unpacking of cartons onto nearest flat surface</li>
            <li>Removal of packing debris at time of delivery</li>
            <li>Export or import clearance if needed to be quoted separately via notes</li>
          </ul>
        </>),
      },
      {
        "label": "DTW (door to warehouse)",
        "labelLong": "Door to warehouse",
        "labelShort": "DTW",
        "value": 2,
        "info": (<>
          <p>We expect the following services to be included, please also see notes for further info:</p>
          <ul>
            <li>Full packing of small and fragile items into cartons</li>
            <li>Normal disassembly of used furniture</li>
            <li>Full itemized English packing inventory</li>
            <li>Traditional blanket wrap loading or full export wrap, pending on option selected under packing type</li>
            <li>Loading from residence of normal access, max ground and/or 1st and/or 2nd floor</li>
            <li>Road transport to your warehouse and warehouse handling</li>
            <li>Max 2 weeks free storage at your warehouse</li>
            <li>FOT loading onto truck at your warehouse</li>
            <li>Pending on destination in request also include transport to our warehouse</li>
            <li>Export or import clearance if needed to be quoted separately via notes</li>
          </ul>
        </>),
      },
      {
        "label": "OS (origin services)",
        "labelLong": "Origin services",
        "labelShort": "OS",
        "value": 3,
        "info": (<>
          <p>We expect the following services to be included, please also see notes for further info:</p>
          <ul>
            <li>Full packing of small and fragile items into cartons</li>
            <li>Normal disassembly of used furniture</li>
            <li>Full itemized English packing inventory</li>
            <li>Traditional blanket wrap loading or full export wrap, pending on option selected under packing type</li>
            <li>Loading from residence of normal access, max ground and/or 1st and/or 2nd floor</li>
            <li>FOT loading onto truck at residence, we will arrange transport</li>
            <li>Export or import clearance if needed to be quoted separately via notes</li>
          </ul>
        </>),
      },
      {
        "label": "OSTR (origin services + freight)",
        "labelLong": "Origin services + freight",
        "labelShort": "OSTR",
        "value": 4,
        "info": (<>
          <p>We expect the following services to be included, please also see notes for further info:</p>
          <ul>
            <li>Full packing of small and fragile items into cartons</li>
            <li>Normal disassembly of used furniture</li>
            <li>Full itemized English packing inventory</li>
            <li>Traditional blanket wrap loading or full export wrap, pending on option selected under packing type</li>
            <li>Loading from residence of normal access, max ground and/or 1st and/or 2nd floor</li>
            <li>FOT loading onto truck at residence</li>
            <li>Transport to destination</li>
            <li>Export or import clearance if needed to be quoted separately via notes</li>
          </ul>
        </>),
      },
      {
        "label": "DS (destination services)",
        "labelLong": "Destination services",
        "labelShort": "DS",
        "value": 5,
        "info": (<>
          <p>We expect the following services to be included, please also see notes for further info:</p>
          <ul>
            <li>Packimpex to arrange transport to the residence</li>
            <li>Unloading into residence of normal access, max ground and/or 1st and/or 2nd floor</li>
            <li>Normal assembly of disassembled used furniture</li>
            <li>Removal of blankets or full unwrapping pending on option selected under packing type</li>
            <li>Unpacking of cartons onto nearest flat surface</li>
            <li>Removal of packing debris at time of delivery</li>
            <li>Export or import clearance if needed to be quoted separately via notes</li>
          </ul>
        </>),
      },
      {
        "label": "TRDS (transport + destination services)",
        "labelLong": "Transport + destination services",
        "labelShort": "TRDS",
        "value": 6,
        "info": (<>
          <p>We expect the following services to be included, please also see notes for further info:</p>
          <ul>
            <li>FOT loading at origin residence to be arrange by Packimpex</li>
            <li>Road transport to residence of destination</li>
            <li>Unloading into residence of normal access, max ground and/or 1st and/or 2nd floor</li>
            <li>Normal assembly of disassembled used furniture</li>
            <li>Removal of blankets or full unwrapping pending on option selected under packing type</li>
            <li>Unpacking of cartons onto nearest flat surface</li>
            <li>Removal of packing debris at time of delivery</li>
            <li>Export or import clearance if needed to be quoted separately via notes</li>
          </ul>
        </>),
      },
      {
        "label": "TR (transport)",
        "labelLong": "Transport",
        "labelShort": "TR",
        "value": 7,
        "info": (<>
          <p>We expect the following services to be included, please also see notes for further info:</p>
          <ul>
            <li>FOT loading at origin residence or warehouse to be arranged by Packimpex</li>
            <li>Transport from origin to destination</li>
            <li>FOT unloading at destination residence or warehouse to be arranged by Packimpex</li>
            <li>Export or import clearance if needed to be quoted separately via notes</li>
          </ul>
        </>),
      },
    ],

    // Sea
    [
      {
        "label": "DTP (door to port) [Sea]",
        "labelLong": "Door to port [Sea]",
        "labelShort": "DTP",
        "value": 8,
        "info": (<></>),
      },
      {
        "label": "PTD (port to door) [Sea]",
        "labelLong": "Port to door [Sea]",
        "labelShort": "PTD",
        "value": 9,
        "info": (<></>),
      },
      {
        "label": "DTD (door to door) [Sea]",
        "labelLong": "Door to door [Sea]",
        "labelShort": "DTD",
        "value": 10,
        "info": (<>
          <p>We expect the following services to be included, please also see notes for further info:</p>
          <ul>
            <li>Full packing of small and fragile items into cartons</li>
            <li>Normal disassembly of used furniture</li>
            <li>Full itemized English packing inventory</li>
            <li>Traditional blanket wrap loading or full export wrap, pending on option selected under packing type</li>
            <li>Loading from residence of normal access, max ground and/or 1st and/or 2nd floor</li>
            <li>Road transport to new residence</li>
            <li>Unloading into residence of normal access, max ground and/or 1st and/or 2nd floor</li>
            <li>Normal assembly of disassembled used furniture</li>
            <li>Removal of blankets or full unwrapping pending on option selected under packing type</li>
            <li>Unpacking of cartons onto nearest flat surface</li>
            <li>Removal of packing debris at time of delivery</li>
            <li>Export or import clearance if needed to be quoted separately via notes</li>
          </ul>
        </>),
      },
    ],
    // Air
    [
      {
        "label": "DTP (door to port) [Air]",
        "labelLong": "Door to port [Air]",
        "labelShort": "DTP",
        "value": 11,
        "info": (<></>),
      },
      {
        "label": "PTD (port to door) [Air]",
        "labelLong": "Port to door [Air]",
        "labelShort": "PTD",
        "value": 12,
        "info": (<></>),
      },
      {
        "label": "DTD (door to door) [Air]",
        "labelLong": "Door to door [Air]",
        "labelShort": "DTD",
        "value": 13,
        "info": (<>
          <p>We expect the following services to be included, please also see notes for further info:</p>
          <ul>
            <li>Full packing of small and fragile items into cartons</li>
            <li>Normal disassembly of used furniture</li>
            <li>Full itemized English packing inventory</li>
            <li>Traditional blanket wrap loading or full export wrap, pending on option selected under packing type</li>
            <li>Loading from residence of normal access, max ground and/or 1st and/or 2nd floor</li>
            <li>Road transport to new residence</li>
            <li>Unloading into residence of normal access, max ground and/or 1st and/or 2nd floor</li>
            <li>Normal assembly of disassembled used furniture</li>
            <li>Removal of blankets or full unwrapping pending on option selected under packing type</li>
            <li>Unpacking of cartons onto nearest flat surface</li>
            <li>Removal of packing debris at time of delivery</li>
            <li>Export or import clearance if needed to be quoted separately via notes</li>
          </ul>
        </>),
      },
    ],
  ],

  "packagingTypes": [
    // Land
    [
      {
        "label": "Blanket wrap",
        "value": 0
      },
      {
        "label": "Export wrap",
        "value": 1
      }
    ],

    // Sea
    [
      {
        "label": "Export wrap [Sea]",
        "value": 2
      }
    ],

    // Air
    [
      {
        "label": "Export wrap [Air]",
        "value": 3
      }
    ],
  ],

  "transportModes" : [
    // Land
    [
      {
        "label": "Direct load",
        "value": 0
      },
      {
        "label": "Combined load",
        "value": 1
      },
    ],

    // Sea
    [
      {
        "label": "40ftHC [Sea]",
        "value": 7
      },
      {
        "label": "40FT [Sea]",
        "value": 8
      },
      {
        "label": "20FT [Sea]",
        "value": 9
      },
      {
        "label": "LCL [Sea]",
        "value": 10
      },
    ],

    // Air
    [
      {
        "label": "Airbox [Air]",
        "value": 6
      },
    ],
  ],
}

export const getRateRequestModeLabel = (freightType = 0, rateRequestMode) => {
  return labels.rateRequestModes[freightType].find((label) => label.value === rateRequestMode)?.labelLong || "";
};

export const getRateRequestModeLabelShort = (freightType = 0, rateRequestMode) => {
  return labels.rateRequestModes[freightType].find((label) => label.value === rateRequestMode)?.labelShort || "";
};

export const getTransportModeLabel = (freightType = 0, transportMode) => {
  return labels.transportModes[freightType].find((label) => label.value === transportMode)?.label || "";
};

export const getRateRequestModeInfo = (freightType = 0, rateRequestMode) => {
  return labels.rateRequestModes[freightType].find((label) => label.value === rateRequestMode)?.info || "";
};

export const getPackagingTypeLabel = (freightType = 0, packagingType) => {
  return labels.packagingTypes[freightType].find((label) => label.value === packagingType)?.label || "";
};

export default labels;
